import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TInternetResourceState } from '~/store/internetResource/internetResource.type';
import {
  internetCategory,
  resourceEduCode,
} from '~/api/oneBoxV3/oneBoxV3.type';
import { getStoredSearchCondition } from '~/utils/helper/localStorage';
import { resolveInternetPageSize } from '~/utils/constants';

const storedSearchCondition = getStoredSearchCondition();

const initialState: TInternetResourceState = {
  searchCondition: {
    // disabled: false,
    category: 'all', //[internetCategory.PUBLIC],
    eduCodes:
      (storedSearchCondition.eduCodes as resourceEduCode | undefined) || 'all',
    years: storedSearchCondition.years || 'all',
    grades: storedSearchCondition.grades || 'all',
    subjects: storedSearchCondition.subjects || 'all',
    resources1: storedSearchCondition.resources1 || null,
    resources2: null,
    fuzzySearch: null,
    fuzzySearchFields: null,
    dateFrom: null,
    dateTo: null,
    isLaunch: false,
    page: 0,
    pageSize: resolveInternetPageSize(storedSearchCondition.resources1),
    sort: '',
  },
  resources: [],
  totalInternetResourcesCount: 0,
};

export const ResourceInternetSlice = createSlice({
  name: 'internetResource',
  initialState,
  reducers: {
    resetSearchCondition: (
      state,
      action: PayloadAction<{
        type: 'admin' | 'client';
        category: internetCategory | 'all';
      }>,
    ) => {
      const { type, category } = action.payload;
      state.searchCondition =
        type === 'admin'
          ? {
              ...state.searchCondition,
              category,
              years: 'all',
              eduCodes: 'all',
              subjects: 'all',
              grades: 'all',
              isLaunch: false,
              page: 0,
              pageSize: 10,
              sort: 'fileUploadTime',
              fuzzySearch: null,
              fuzzySearchFields: null,
            }
          : initialState.searchCondition;
    },
    setSearchCondition: (
      state,
      action: PayloadAction<{
        [title: string]: string | boolean | number | string[];
      }>,
    ) => {
      state.searchCondition = {
        ...state.searchCondition,
        ...action.payload,
      };
    },
  },
});

export const { setSearchCondition, resetSearchCondition } =
  ResourceInternetSlice.actions;

export default ResourceInternetSlice.reducer;
